<div class="container">
  <div class="maintenance-cases">
    <div class="maintenance-cases__header">
      <div class="maintenance-cases__header-info">
        <div class="title">
          {{ "MAINTENANCE.TITLE_MAINTENANCE_CASES" | translate }}
        </div>
        <div class="maintenance-cases__header-text">
          {{ "MAINTENANCE.TITLE_CASES" | translate }}
        </div>
      </div>
    </div>
    <div class="maintenance-cases__interval">
      <div class="maintenance-cases__interval__header">
        <h5 class="maintenance-cases__interval__header__title">{{ "MAINTENANCE.DEFINED_INTERVAL" | translate }}</h5>
        <div class="maintenance-cases__interval__header__chip"  *ngIf="currentStatus"
        [ngClass]="{
          'maintenance-cases__interval__header__chip--enabled': currentStatus === 'Enabled',
          'maintenance-cases__interval__header__chip--disabled': currentStatus === 'Disabled',
          'maintenance-cases__interval__header__chip--online': currentStatus === 'Online'}"
        >
          <span *ngIf="currentStatus === 'Enabled'">{{ "MAINTENANCE.CASES_ENABLED" | translate }}</span>
          <span *ngIf="currentStatus === 'Disabled'">{{ "MAINTENANCE.CASES_DISABLED" | translate }}</span>
          <span *ngIf="currentStatus === 'Online'">{{ "MAINTENANCE.CASES_STATUS_ONLINE" | translate }}</span>
        </div>
      </div>
      <div class="maintenance-cases__interval__group">

        <div class="maintenance-cases__interval__group__item">
          <label class="bz-form-label">
            {{ "MAINTENANCE.CASES_START_TIME" | translate }}
          </label>
          <div class="bz-form-item__control">
            <div class="bz-control bz-time-picker">
              <div class="bz-time-picker__section bz-space--inline-xs">
                <input
                  class="bz-input bz-time-picker__section__input maintenance-cases__interval__group__item__input--disabled"
                  name="hoursInputStartTime"
                  type="number"
                  [ngModel]="initialIntervalStartTime.hours"
                  disabled
                />
              </div>
              <div class="bz-time-picker__separator bz-space--inline-xs">
                :
              </div>
              <div class="bz-time-picker__section">
                <input
                  class="bz-input bz-time-picker__section__input maintenance-cases__interval__group__item__input--disabled"
                  name="minutesInputStartTime"
                  type="number"
                  [ngModel]="initialIntervalStartTime.minutes"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
        <div class="maintenance-cases__interval__group__item">
          <label class="bz-form-label">
            {{ "MAINTENANCE.CASES_END_TIME" | translate }}
          </label>
          <div class="bz-form-item__control">
            <div class="bz-control bz-time-picker">
              <div class="bz-time-picker__section bz-space--inline-xs">
                <input
                  class="bz-input bz-time-picker__section__input maintenance-cases__interval__group__item__input--disabled"
                  name="hoursInputEndTime"
                  type="number"
                  [ngModel]="initialIntervalEndTime.hours"
                  disabled
                />
              </div>
              <div class="bz-time-picker__separator bz-space--inline-xs">
                :
              </div>
              <div class="bz-time-picker__section">
                <input
                  class="bz-input bz-time-picker__section__input maintenance-cases__interval__group__item__input--disabled"
                  name="minutesInputEndTime"
                  type="number"
                  [ngModel]="initialIntervalEndTime.minutes"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="maintenance-cases__interval">
      <div class="maintenance-cases__interval__header">
        <bzg-checkbox class="maintenance-cases__interval__header__title" (change)="setNewInterval()" [(ngModel)]="isEditingMode">{{ "MAINTENANCE.SET_INTERVAL" | translate }}</bzg-checkbox>
      </div>
      <form class="maintenance-cases__interval__group">
        <div class="maintenance-cases__interval__group__item">
          <label class="bz-form-label">
            {{ "MAINTENANCE.CASES_START_TIME" | translate }}
          </label>
          <div class="bz-form-item__control">
            <div class="bz-control bz-time-picker">
              <div class="bz-time-picker__section bz-space--inline-xs">
                <input
                  class="bz-input bz-time-picker__section__input"
                  [ngClass]="{ 'maintenance-cases__interval__group__item__input--disabled': !isEditingMode }"
                  name="hoursInputStart"
                  type="number"
                  (keypress)="onlyNumbers($event)"
                  [(ngModel)]="startTime.hours"
                  (ngModelChange)="checkValue(_startTimeDebounce, 'hours', $event)"
                  [disabled]="!isEditingMode"
                />
                <div class="bz-time-picker__arrows">
                  <svg
                    class="bz-time-picker__arrows__item"
                    [ngClass]="{'maintenance-cases__interval__group__item__input--disabled': !isEditingMode}"
                    (click)="goUp(startTime, 'hours')"
                  >
                    <use xlink:href="#arrow-up" />
                  </svg>
                  <svg
                    class="bz-time-picker__arrows__item"
                    [ngClass]="{'maintenance-cases__interval__group__item__input--disabled': !isEditingMode}"
                    (click)="goDown(startTime, 'hours')"
                  >
                    <use xlink:href="#arrow-down" />
                  </svg>
                </div>
              </div>
              <div class="bz-time-picker__separator bz-space--inline-xs">
                :
              </div>
              <div class="bz-time-picker__section">
                <input
                  class="bz-input bz-time-picker__section__input"
                  [ngClass]="{ 'maintenance-cases__interval__group__item__input--disabled': !isEditingMode }"
                  name="minutesInputStart"
                  type="number"
                  (keypress)="onlyNumbers($event)"
                  [(ngModel)]="startTime.minutes"
                  (ngModelChange)="checkValue(_startTimeDebounce, 'minutes', $event)"
                  [disabled]="!isEditingMode"
                />
                <div class="bz-time-picker__arrows">
                  <svg
                    class="bz-time-picker__arrows__item"
                    [ngClass]="{'maintenance-cases__interval__group__item__input--disabled': !isEditingMode}"
                    (click)="goUp(startTime, 'minutes')"
                  >
                    <use xlink:href="#arrow-up" />
                  </svg>
                  <svg
                    class="bz-time-picker__arrows__item"
                    [ngClass]="{'maintenance-cases__interval__group__item__input--disabled': !isEditingMode}"
                    (click)="goDown(startTime, 'minutes')"
                  >
                    <use xlink:href="#arrow-down" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="maintenance-cases__interval__group__item">
          <label class="bz-form-label">
            {{ "MAINTENANCE.CASES_END_TIME" | translate }}
          </label>
          <div class="bz-form-item__control">
            <div class="bz-control bz-time-picker">
              <div class="bz-time-picker__section bz-space--inline-xs">
                <input
                  class="bz-input bz-time-picker__section__input"
                  [ngClass]="{ 'maintenance-cases__interval__group__item__input--error': !isEndTimeAfterStartTime,
                  'maintenance-cases__interval__group__item__input--disabled': !isEditingMode}"
                  name="hoursInputEnd"
                  type="number"
                  (keypress)="onlyNumbers($event)"
                  [(ngModel)]="endTime.hours"
                  (ngModelChange)="checkValue(_endTimeDebounce, 'hours', $event)"
                  [disabled]="!isEditingMode"
                />
                <div class="bz-time-picker__arrows">
                  <svg
                    class="bz-time-picker__arrows__item"
                    [ngClass]="{'maintenance-cases__interval__group__item__input--disabled': !isEditingMode}"
                    (click)="goUp(endTime, 'hours')"
                  >
                    <use xlink:href="#arrow-up" />
                  </svg>
                  <svg
                    class="bz-time-picker__arrows__item"
                    [ngClass]="{'maintenance-cases__interval__group__item__input--disabled': !isEditingMode}"
                    (click)="goDown(endTime, 'hours')"
                  >
                    <use xlink:href="#arrow-down" />
                  </svg>
                </div>
              </div>
              <div class="bz-time-picker__separator bz-space--inline-xs">
                :
              </div>
              <div class="bz-time-picker__section">
                <input
                  class="bz-input bz-time-picker__section__input"
                  [ngClass]="{ 'maintenance-cases__interval__group__item__input--error': !isEndTimeAfterStartTime,
                  'maintenance-cases__interval__group__item__input--disabled': !isEditingMode}"
                  name="minutesInputEnd"
                  type="number"
                  (keypress)="onlyNumbers($event)"
                  [(ngModel)]="endTime.minutes"
                  (ngModelChange)="checkValue(_endTimeDebounce, 'minutes', $event)"
                  [disabled]="!isEditingMode"
                />
                <div class="bz-time-picker__arrows">
                  <svg
                    class="bz-time-picker__arrows__item"
                    [ngClass]="{'maintenance-cases__interval__group__item__input--disabled': !isEditingMode}"
                    (click)="goUp(endTime, 'minutes')"
                  >
                    <use xlink:href="#arrow-up" />
                  </svg>
                  <svg
                    class="bz-time-picker__arrows__item"
                    [ngClass]="{'maintenance-cases__interval__group__item__input--disabled': !isEditingMode}"
                    (click)="goDown(endTime, 'minutes')"
                  >
                    <use xlink:href="#arrow-down" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <h4 *ngIf="!isEndTimeAfterStartTime" class="maintenance-cases__interval__group__item__error-message">
            {{ "MAINTENANCE.CASES_ERROR_TIME" | translate }}
          </h4>

        </div>

        <div class="maintenance-cases__interval__group__buttons"
        [ngClass]="{ 'maintenance-cases__interval__group__buttons--error-form': !isEndTimeAfterStartTime }">
          <bzg-button-primary
            class="mc-maintenance__buttons-save"
            [disabled]="disableSetTimeButton()"
            (click)="savejobData()"
            >{{ "MAINTENANCE.CASES_SET_TIME" | translate }}</bzg-button-primary
          >
        </div>
      </form>
    </div>
  </div>
</div>
